import { render, staticRenderFns } from "./win.vue?vue&type=template&id=4edb63e3&scoped=true&"
import script from "./win.vue?vue&type=script&lang=js&"
export * from "./win.vue?vue&type=script&lang=js&"
import style0 from "./win.vue?vue&type=style&index=0&id=4edb63e3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edb63e3",
  null
  
)

export default component.exports